<template>
  <!--header-->
  <b-navbar type="dark" class="header" toggleable="ms" fixed="top">
    <b-navbar-brand href="#" class="logo">
      <img src="https://image-service.loewe-zaun.de/production/55bf8eed15979.png">
    </b-navbar-brand>
    <router-link :to="{ name: 'checkout.cart' }" class="cart-link">
      <fa icon="shopping-cart" />
      <span>{{ countItems }}</span>
    </router-link>
    <b-navbar-toggle target="navbar-collapse" right />
    <b-collapse id="navbar-collapse" is-nav>
      <b-navbar-nav>
        <span v-for="(item, index) in getNav" :key="index">
          <b-nav-item-dropdown v-if="item.children.length > 0" :text="item.name">
            <b-dropdown-item v-for="child in item.children" :key="child.id" :href="child.url" :target="child.target">{{ child.name }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-else :href="item.url" :target="item.target">{{ item.name }}</b-nav-item>
        </span>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    appName: window.config.appName
  }),
  computed: {
    ...mapGetters({
      navigation: 'menu/menu',
      items: 'checkout/items'
    }),
    getNav () {
      const data = this.buildTree(this.navigation)
      return data
    },
    countItems () {
      return this.items.length
    }
  },
  mounted () {
    this.setMenu()
  },
  methods: {
    ...mapActions({
      setMenu: 'menu/setMenu'
    }),
    buildTree (elements, parentId = 0) {
      // eslint-disable-next-line
      let branch = []
      if (elements) {
        elements.forEach(element => {
          if (element.parent_id === parentId) {
            const children = this.buildTree(elements, element.id)
            if (children) {
              // eslint-disable-next-line
              element['children'] = children
            }
            branch.push(element)
          }
        })
      }
      return branch
    }
  }
}
</script>
